<template>
    <div class="card-loader-overlay" :class="{locked: locked}" :data-type="type">
        <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      locked: Boolean,
      type: {
        type: String,
        default: 'normal'
      },
    },
  };
</script>

<style lang="scss">
    .card-body {
        .card-loader-overlay {
            background: #1e1f25;
            box-shadow: none;
        }
    }

    .card-loader-overlay {
        background: black;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 1.25rem;
        box-shadow: 0 0 1px 1px black;
        border-radius: 0.2rem;
        opacity: 0;
        visibility: hidden;
        transition: opacity 600ms, visibility 600ms;

        &.locked {
            visibility: visible;
            opacity: 0.8;
        }

        &[data-type="small"] {
            .lds-spinner {
                transform: scale(.5);
            }
        }

        &[data-type="reverse"] {
            .lds-spinner {
                transform: scaleX(-1);
            }
        }

        .lds-spinner {
            display: inline-block;
            position: relative;
            width: 64px;
            height: 64px;

            & div {
                transform-origin: 32px 32px;
                animation: lds-spinner 1.2s linear infinite;

                &:after {
                    content: " ";
                    display: block;
                    position: absolute;
                    top: 3px;
                    left: 29px;
                    width: 5px;
                    height: 14px;
                    border-radius: 20%;
                    background: #fff;
                }

                &:nth-child(1) {
                    transform: rotate(0deg);
                    animation-delay: -1.1s;
                }

                &:nth-child(2) {
                    transform: rotate(30deg);
                    animation-delay: -1s;
                }

                &:nth-child(3) {
                    transform: rotate(60deg);
                    animation-delay: -0.9s;
                }

                &:nth-child(4) {
                    transform: rotate(90deg);
                    animation-delay: -0.8s;
                }

                &:nth-child(5) {
                    transform: rotate(120deg);
                    animation-delay: -0.7s;
                }

                &:nth-child(6) {
                    transform: rotate(150deg);
                    animation-delay: -0.6s;
                }

                &:nth-child(7) {
                    transform: rotate(180deg);
                    animation-delay: -0.5s;
                }

                &:nth-child(8) {
                    transform: rotate(210deg);
                    animation-delay: -0.4s;
                }

                &:nth-child(9) {
                    transform: rotate(240deg);
                    animation-delay: -0.3s;
                }

                &:nth-child(10) {
                    transform: rotate(270deg);
                    animation-delay: -0.2s;
                }

                &:nth-child(11) {
                    transform: rotate(300deg);
                    animation-delay: -0.1s;
                }

                &:nth-child(12) {
                    transform: rotate(330deg);
                    animation-delay: 0s;
                }
            }
        }

        @keyframes lds-spinner {
            0% {
                opacity: 1;
            }
            100% {
                opacity: 0;
            }
        }
    }
</style>
